import { motion } from "framer-motion";

// Signature on-load moment: masked line-by-line reveal.
// `lines` is an array of strings; each rises from behind a clip mask.
export default function MaskedLines({ lines, className = "", style = {}, delay = 0 }) {
  return (
    <h1 className={className} style={style} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden" style={{ paddingBottom: "0.06em" }}>
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}
